export class MockIntersectionObserver {
  constructor() {
    /**/
  }

  disconnect() {
    /**/
  }

  observe() {
    /**/
  }

  takeRecords(): any[] {
    return [];
  }

  unobserve() {
    /**/
  }
}
